module.exports = __webpack_public_path__ + "static/media/005_devsupplychain_viz.22e11155.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/005_devsupplychain_viz.png
// module id = 638
// module chunks = 0